import React, { useEffect } from 'react';
import NProgress from 'nprogress';
import { Box, LinearProgress, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

const LoadingScreen = ({ circular }) => {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: theme.palette.background.default,
        height: '100%',
        minHeight: '100%',
        p: circular ? 1 : 3,
        width: '100%'
      })}
    >
      <Box sx={{ width: circular ? null : '75%' }}>
        {circular ? <CircularProgress /> : <LinearProgress />}
      </Box>
    </Box>
  );
};

LoadingScreen.propTypes = {
  circular: PropTypes.bool
};

LoadingScreen.defaultProps = {
  circular: false
};

export default LoadingScreen;
